import { Component, Input } from '@angular/core';
import { OcrPlusComponent } from '../ocr-plus/ocr-plus.component';

@Component({
  selector: 'app-ocr-plus-txt',
  templateUrl: './ocr-plus-txt.component.html',
  styleUrls: ['./ocr-plus-txt.component.css'],
})
export class OcrPlusTxtComponent {
  @Input() ocrPlus: OcrPlusComponent;
  @Input() jsonData: any;

  getJsonData(): any {
    if (this.jsonData) {
      return this.jsonData.data;
    }
    return [];
  }

  itemOver(item) {
    for (let i of this.getJsonData()) {
      i.chosen = false;
    }
    item.chosen = true;
    this.ocrPlus.itemOver(item.type, item);
  }

  mouseDown(x: number, y: number) {
    this.getJsonData().forEach((item, index) => {
      if (this.isPointInBox(item, x, y)) {
        this.itemOver(item);
        const elem = document.getElementById('item_'+index);
        if (elem) elem.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  isPointInBox(item, x: number, y: number): boolean {
    const box = item.bbox;
    const left = box[0],
      bottom = box[1],
      right = box[2],
      top = box[3];
    return x >= left && x <= right && y >= bottom && y <= top;
  }
}
